import axios from "axios";
import styled from "styled-components";
import { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Avatar, Button, Table } from "@mantine/core";
import { Link } from "react-router-dom";
import { SkillsFilter } from "./SoftSkillsFilter";
import {
  AdjustmentsAlt,
  ChevronLeft,
  ChevronRight,
  Refresh,
  TableExport,
} from "tabler-icons-react";
import * as XLSX from "xlsx";
import moment from "moment";
import { Trash } from "tabler-icons-react";

export const SoftSkillsForms = ({ props }) => {
  const { program } = props;

  const [answersData, setAnswersData] = useState({});
  const [skillsLoading, setSkillsLoading] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);

  let link = "/skill/list";

  const { isLoading } = useQuery(
    [`answers`],
    async () => await axios.get(link).then((res) => res.data),
    {
      onSuccess: (data) => {
        setAnswersData(data);
      },
    }
  );

  const { mutate: reFetch, isLoading: refetching } = useMutation(
    [`answers refetch`],
    async () => await axios.get(link).then((res) => res.data),
    {
      onSuccess: (data) => {
        setAnswersData(data);
      },
    }
  );

  const { mutate: fetchPage, isLoading: pageFetchLoading } = useMutation(
    [`answers page`],
    async (link) => {
      let linkWithS = link.replace("http", "https");
      return await axios.get(linkWithS).then((res) => res.data);
    },
    {
      onSuccess: (data) => {
        setAnswersData(data);
      },
    }
  );

  function exportData() {
    let arrayX = [];

    answersData?.data?.map((item) => {
      arrayX.push({
        ["Owner Id"]: item?.owner_id,
        ["Form Name"]: item?.form_name,
        ["Created At"]: moment(item?.created_at).format("YYYY MM DD"),
      });
    });

    console.log("🚀 | exportData | arrayX:", arrayX);

    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(arrayX);

    XLSX.utils.book_append_sheet(wb, ws, "Answers data");

    XLSX.writeFile(wb, "Answers.xlsx");
  }

  function deleteForm(id) {
    axios.delete(`/skill/${id}`).then((_) => {
      reFetch();
    });
  }

  const userArray =
    answersData?.data &&
    answersData?.data.map((item) => {
      return (
        <tr key={item?.id}>
          <td>{item?.owner_id}</td>
          <td>
            <p>{item?.form_name}</p>
          </td>
          <td>
            <p>{moment(item?.created_at).format("YYYY MM DD")}</p>
          </td>
          <td>
            <Button
              m={0}
              color="red"
              variant="outline"
              leftIcon={<Trash />}
              onClick={() => deleteForm(item?.id)}
            >
              Delete
            </Button>
          </td>
        </tr>
      );
    });

  function ReportNavigation() {
    return (
      <div className="navigate">
        {/* <Button
          loading={refetching || isLoading || pageFetchLoading}
          variant="outline"
          color="dark"
          radius="sm"
          fullWidth
          leftIcon={<AdjustmentsAlt />}
          onClick={() => setFilterOpen(true)}
        >
          Filter
        </Button> */}
        {/* <Button
          variant="outline"
          color="dark"
          leftIcon={<ChevronLeft />}
          disabled={answersData?.previous === null}
          onClick={() => fetchPage(answersData?.previous)}
        >
          Prev
        </Button>
        <Button
          variant="outline"
          color="dark"
          rightIcon={<ChevronRight />}
          disabled={answersData?.next === null}
          onClick={() => fetchPage(answersData?.next)}
        >
          Next
        </Button> */}
        <Button
          leftIcon={<TableExport />}
          color={"gray.7"}
          onClick={() => exportData()}
        >
          Export
        </Button>
      </div>
    );
  }

  return (
    <ReportStyle>
      <div className="reportHead">
        <h2>Answers</h2>
        <div>
          <h3>Entries: {answersData?.data?.length}</h3>
          <Button onClick={() => reFetch()} variant="default">
            <Refresh />
          </Button>
        </div>
      </div>

      <ReportNavigation />

      <div className="users">
        <div className="answersData">
          <Table className="reportTable">
            <thead>
              <tr>
                <th>Owner Id</th>
                <th>Form Name</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody className="tableEntries">{userArray}</tbody>
          </Table>
        </div>
      </div>

      <SkillsFilter
        props={{
          program: "taskilled",
          filterOpen,
          setFilterOpen,
          reFetch,
          setSkillsLoading,
          answersData,
          setAnswersData,
        }}
      />
    </ReportStyle>
  );
};

const ReportStyle = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 1.5rem;
  hr {
    border: none;
    border-bottom: 1px solid #bbb;
  }
  .reportHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* background-color: #f8f9fa; */
    /* padding: 0 .5rem; */
    border-radius: 0.25rem;
    h2,
    h3 {
      font-weight: 500;
      margin: 0;
    }
    div {
      display: flex;
      align-items: center;
      grid-gap: 1rem;
    }
  }
  .navigate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    /* margin: 1rem; */
    button {
      font-weight: 500;
    }
  }
  .reportTable {
    .tableEntries {
      p {
        min-width: max-content;
      }
    }
  }
  .userCode {
    display: flex;
    grid-gap: 0.25rem;
  }
  .users {
    .wishlist {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      padding: 1rem;
      background-color: #e9ecef;
      display: flex;
      flex-direction: column;
      grid-gap: 0.75rem;
      h3 {
        font-weight: 500;
        margin: 0;
      }
      li {
        list-style: none;
        background: #dee2e6;
        padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
      }
    }
  }
  .answersData {
    width: 99%;
    max-width: 99%;
    margin: 0 auto;
    height: 620px;
    max-height: 620px;
    overflow: scroll;
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      /* margin-top: 1rem; */
    }

    ::-webkit-scrollbar-track {
      margin-top: 2.2rem;
      border-radius: 1rem;
      background: rgba(126, 126, 126, 0);
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 1rem;
      background: rgba(126, 126, 126, 0.5);
    }

    ::-webkit-scrollbar-thumb:hover {
      background: rgba(126, 126, 126, 1);
    }
  }
`;
